export default __webpack_public_path__ + "static/media/micro-aventure-favicon.9c927e36.svg";